import React from 'react';
import Clear from "material-ui/svg-icons/content/clear";

function DialogTitle(props) {
  return (
    <div
        style={{
          backgroundColor: "#657285",
          padding: "12px 16px",
          color: "#fff",
          minHeight: '60px'
        }}
        className="d-flex align-center justify-between"
      >
        <span style={{ fontSize: "15px" }}>
          {props.heading}
        </span>
        <Clear
          onClick={props.handleClose}
          style={{ fill: "#fff", cursor: "pointer", width: '30px', height: '30px' }}
        />
      </div>
  )
}

export default DialogTitle;


// WEBPACK FOOTER //
// src/components/Shared/DialogTitle.js